import createReducer from '../utils/createReducer';
import {
  BOOK_QUERY_SUCCESS,
} from '../constants/actions';

const initialState = {
  data: [],
};

export default createReducer(initialState, {
  [BOOK_QUERY_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: payload.data,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/bookQuery.js